import React from 'react';
import { Page } from '../Page';
export function PageDoseManagement2() {
  return <Page pageNumber={6} variant="light" data-id="element-1360" data-mp="2rx5vspn8aiyb">
      <div className="flex flex-col h-full" data-id="element-1361" data-mp="2ry7ijrdlwtvv">
        <div className="grid grid-cols-2 gap-10 flex-1 mt-2" data-id="element-1362" data-mp="36u6p2xl2ilyw">
          {/* Left Column - fills to the bottom */}
          <div className="flex flex-col space-y-4" data-id="element-1363" data-mp="31vddxbt9771w">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1364" data-mp="31tsf39zwp1y8">
              That's useful feedback. It doesn't automatically mean you need to
              increase, but it can be a sign that your current dose isn't
              lasting the full week.
            </p>

            {/* Zepbound Dose Progression Image */}
            <div className="py-1" data-id="element-1365" data-mp="3pmitrqz71zc7">
              <img src="https://cdn.magicpatterns.com/uploads/94D4dNseC7uLTKHQ9PqeHn/zepbound_transparent.png" alt="Dose Progression (Zepbound) - 2.5mg to 15mg" className="w-full h-auto object-contain" data-id="element-1366" data-mp="3klbivj1r8k1b" />
            </div>

            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1367" data-mp="q5dv0zgzzxet">
              If you're already losing weight, eating well, and your hunger
              feels under control, there's no clear benefit to increasing just
              because it's time. In some cases, increasing too quickly can lead
              to more side effects without improving your results.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1368" data-mp="193q3sk3zz59v">
              On the other hand, if progress has stalled for several weeks or
              hunger and food noise are still getting in the way, that's when
              increasing the dose can make a real difference.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1369" data-mp="1mv4yvpb6iwxa">
              A lower effective dose usually means fewer side effects, better
              nutrition, and a smoother transition when it's time to come off
              the medication.
            </p>
          </div>

          {/* Right Column - overflow */}
          <div className="flex flex-col space-y-4" data-id="element-1370" data-mp="174dpnyl92oy3">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1371" data-mp="1732n223jjn8k">
              It also makes the whole process easier to sustain, which is what
              actually drives long-term results.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}